<script>
import { layoutComputed } from '@/state/helpers';

import router from '@/router';
import Topbar from '@/components/Topbar/main.vue';
import SideBar from '@/components/Sidebar/main.vue';
import Rightsidebar from '@/components/RightSideBar/main.vue';
import PageHeader from '@/components/PageHeader/main.vue';

export default {
    components: { Topbar, SideBar, Rightsidebar, PageHeader },
    data() {
        return {
            isMenuCondensed: false,
            listRouterName: ['CampaignEdit', 'CampaignView', 'Documents']
        };
    },
    created: () => {
        document.body.removeAttribute('data-layout', 'horizontal');
        document.body.removeAttribute('data-topbar', 'dark');
        document.body.setAttribute('data-sidebar', 'dark');
    },
    computed: {
        ...layoutComputed,
        overflowCampaign() {
            if (this.listRouterName.includes(this.$route.name)) return true;
            return false;
        },
        breadcrumbConfig() {
            let title = '';
            let pageItems = [];

            if (!this.$route?.meta?.typeRouterForm) {
                title = this.$route.meta?.titleJP;
                pageItems = this.$route.meta?.pageNames;
            }
            if (this.$route?.meta?.typeRouterForm) {
                if (!this.$route?.query?.id) {
                    title = this.$route.meta?.titleJPAdd;
                    pageItems = this.$route.meta?.pageNamesAdd;
                } else {
                    title = this.$route.meta?.titleJPEdit;
                    pageItems = this.$route.meta?.pageNamesEdit;
                }
            }
            return {
                title,
                pageItems
            };
        }
    },
    methods: {
        toggleMenu() {
            document.body.classList.toggle('sidebar-enable');

            if (window.screen.width >= 992) {
                router.afterEach(() => {
                    document.body.classList.remove('sidebar-enable');
                    document.body.classList.remove('vertical-collpsed');
                });
                document.body.classList.toggle('vertical-collpsed');
            } else {
                router.afterEach(() => {
                    document.body.classList.remove('sidebar-enable');
                });
                document.body.classList.remove('vertical-collpsed');
            }
            this.isMenuCondensed = !this.isMenuCondensed;
        },
        toggleRightSidebar() {
            document.body.classList.toggle('right-bar-enabled');
        },
        hideRightSidebar() {
            document.body.classList.remove('right-bar-enabled');
        },
        handleBreadcrumb(param) {
            return param?.filter((item) => item.text !== '');
        }
    },
    mounted() {
        document.body.classList.remove('auth-body-bg');
        if (this.loader === true) {
            document.getElementById('preloader').style.display = 'block';
            document.getElementById('status').style.display = 'block';

            setTimeout(function () {
                document.getElementById('preloader').style.display = 'none';
                document.getElementById('status').style.display = 'none';
            }, 2500);
        } else {
            document.getElementById('preloader').style.display = 'none';
            document.getElementById('status').style.display = 'none';
        }

        if (
            window.location.href.includes('/edit') ||
            (window.location.href.includes('/form') &&
                !window.location.href.includes('/form/view') &&
                !window.location.href.includes('/form/support/view'))
        ) {
            document.getElementById('page-content').classList.add('mystyle');
        }
    }
};
</script>

<template>
    <div>
        <div id="preloader">
            <div id="status">
                <div class="spinner">
                    <i class="ri-loader-line spin-icon"></i>
                </div>
            </div>
        </div>

        <!-- Begin page -->
        <div id="layout-wrapper">
            <Topbar />
            <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
            <div class="main-content" :class="{ overflow_campaign: overflowCampaign }">
                <div class="page-content" id="page-content">
                    <b-breadcrumb :items="handleBreadcrumb(breadcrumbConfig.pageItems)" class="mb-3" style="background-color: #fff"></b-breadcrumb>
                    <div class="container-fluid px-4">
                        <PageHeader />
                        <slot />
                    </div>
                </div>
            </div>
            <Rightsidebar />
        </div>
    </div>
</template>
